import { render, staticRenderFns } from "./COVID19.vue?vue&type=template&id=dd02ce32&scoped=true&"
import script from "./COVID19.vue?vue&type=script&lang=js&"
export * from "./COVID19.vue?vue&type=script&lang=js&"
import style0 from "./COVID19.vue?vue&type=style&index=0&id=dd02ce32&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd02ce32",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer,VRow})
